(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[209],{

/***/ 1225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4168);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(539);
/* harmony import */ var _utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3289);



/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const [match, setMatch] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  });
  (0,_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    let active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    const queryList = matchMedia(query);

    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch(); // TODO: Use `addEventListener` once support for Safari < 14 is dropped

    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);
  return match;
} // eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814


const maybeReactUseSyncExternalStore = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useSyncExternalStore' + ''];

function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia) {
  const getDefaultSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }

    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia]);
  const [getSnapshot, subscribe] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }

    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}

function useMediaQuery(queryInput, options = {}) {
  const theme = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(); // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr
  } = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });

  if (false) {}

  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable

  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);

  if (false) {}

  return match;
}

/***/ }),

/***/ 9609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(7078);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createBox.js
var createBox = __webpack_require__(1354);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/Box/boxClasses.js

const boxClasses = (0,generateUtilityClasses/* default */.Z)('MuiBox', ['root']);
/* harmony default export */ var Box_boxClasses = (boxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/Box/Box.js
'use client';





const Box = (0,createBox/* default */.Z)({
  defaultClassName: Box_boxClasses.root,
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 6617:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies-policy",
      function () {
        return __webpack_require__(8387);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(120);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5084);
/* harmony import */ var _mui_material_Toolbar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(784);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2097);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1225);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6896);
/* harmony import */ var src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1268);
/* harmony import */ var src_configs_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8958);
/* harmony import */ var src_layouts_components_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4381);
/* harmony import */ var src_context_HistoryContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9930);
// ** React Imports


// ** Next Imports


// ** Mui Imports





// ** Modules Imports

// ** Source code Imports




const DocsLayout = (param)=>{
    let { sx , title , children  } = param;
    const { formatMessage  } = (0,react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const history = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_context_HistoryContext__WEBPACK_IMPORTED_MODULE_7__/* .HistoryContext */ .T);
    const theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    const smallMatch = (0,_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(theme.breakpoints.down("sm"));
    const { settings  } = (0,src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const { mode  } = settings;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        sx: {
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Toolbar__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    sx: {
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            sx: {
                                width: 120,
                                display: "flex",
                                justifyContent: "flex-start"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: src_configs_api__WEBPACK_IMPORTED_MODULE_5__/* ["default"].landingUrl */ .Z.landingUrl,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_layouts_components_icons__WEBPACK_IMPORTED_MODULE_6__/* .Logotype */ .Vp, {
                                    sx: {
                                        px: 2
                                    },
                                    height: 32,
                                    mode: mode
                                })
                            })
                        }),
                        !smallMatch && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                title: title,
                                variant: "h5",
                                component: "div",
                                sx: {
                                    width: 1,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textAlign: "center"
                                },
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            sx: {
                                width: 120,
                                display: "flex",
                                justifyContent: "flex-end"
                            },
                            children: history.length > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                sx: {
                                    ml: 2
                                },
                                onClick: ()=>router.back(),
                                color: "inherit",
                                children: formatMessage({
                                    id: "back"
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                sx: {
                                    ml: 2
                                },
                                onClick: ()=>router.push("/"),
                                color: "inherit",
                                children: formatMessage({
                                    id: "go-home"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                sx: {
                    width: 1,
                    py: 2,
                    ...sx
                },
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DocsLayout);


/***/ }),

/***/ 8387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(754);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6896);
/* harmony import */ var effector_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4190);
/* harmony import */ var src_state_manager_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2154);
/* harmony import */ var src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1872);
/* harmony import */ var src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(662);
/* harmony import */ var src_layouts_DocsLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6362);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9609);
/* harmony import */ var src_state_manager_landing__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2088);
// ** React Imports


// ** MUI Imports

// ** Modules Imports


// ** Source code Imports






const keyValuesKeys = src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_3__/* ["default"].keyValues */ .Z.keyValues;
const keyValuesEnum = src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_4__/* ["default"].keyValues */ .Z.keyValues;
const CookiesPolicy = ()=>{
    const { formatMessage  } = (0,react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const { language  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_8__/* .useStore */ .oR)(src_state_manager_global__WEBPACK_IMPORTED_MODULE_2__/* ["default"].locale */ .ZP.locale);
    const { landingDetails  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_8__/* .useStore */ .oR)(src_state_manager_landing__WEBPACK_IMPORTED_MODULE_6__/* ["default"].landing */ .ZP.landing);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_6__/* .getLandingDetail */ .d_)({
            query: {
                $or: [
                    {
                        "data.groupName": "landing"
                    },
                    {
                        "data.groupName": "shared"
                    }
                ],
                $and: [
                    {
                        ["data.".concat(keyValuesKeys.language)]: language === "ru" ? keyValuesEnum.language.ru : keyValuesEnum.language.en
                    }
                ]
            }
        });
    }, [
        language
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_layouts_DocsLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        sx: {
            maxWidth: 768,
            height: landingDetails.loading ? "auto" : "calc(100vh - 64px)",
            mx: "auto"
        },
        title: formatMessage({
            id: "cookies-policy"
        }),
        children: landingDetails.loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_system__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            sx: {
                display: "flex",
                justifyContent: "center",
                pt: 16
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                size: 72
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            width: "100%",
            height: "100%",
            style: {
                border: 0,
                padding: 0
            },
            srcDoc: landingDetails.data["cookies-policy-text"]
        })
    });
};
CookiesPolicy.getLayout = (page)=>page;
CookiesPolicy.guestGuard = true;
CookiesPolicy.acl = {
    action: "read",
    subject: "cookies-policy-page"
};
/* harmony default export */ __webpack_exports__["default"] = (CookiesPolicy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [476,997,774,888,179], function() { return __webpack_exec__(6617); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);